import React, { Fragment } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { isEmpty, dateFormation,convertResultType, convertTypeString, convertClass, getBetGameName, getBetGameLeague, convertBetMarketName, convertBetHistoryDetail } from '../../../common/cores';


const BetGameHistory = (props) => {

    // console.log(props);

    const { history, page, index } = props

    return (
        <Fragment key={index}>
            {isEmpty(history.odds) ? '' : (
                history.odds.map((odd, oddKey) => (
                    <tr key={oddKey}>
                    { oddKey === 0 && <td className="bet_history_td" rowSpan={history.odds.length}>{isNaN(page.curPage) ? 0 : (page.curPage - 1) * 10 + index + 1}</td>}
                    {/* { oddKey === 0 && <td className="col-1" rowSpan={history.odds.length}><div style={{wordWrap:"break-word"}}>{history._id}</div></td>} */}
                    <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history) ? '' : getBetGameName(odd.key.split("_")[0])} <br/>{ getBetGameLeague(odd.key.split("_")[0], odd.key.split("_")[2])}</td>
                    {/* <td data-v-9dbb6d4c className="">
                        {isEmpty(history.extraData) ? '' : history.extraData.stadium}
                    </td> */}
                    {/* <td data-v-9dbb6d4c className="">
                        {
                        isEmpty(history.extraData) || isEmpty(history.extraData.participants) ? '' :
                            `${history.extraData.participants[0].name_kor} : ${history.extraData.participants[1].name_kor}`
                        }
                    </td>
                    <td data-v-9dbb6d4c className="">{isEmpty(history.extraData) ? '' : dateFormation(history.extraData.time, 1)}</td> */}
                    <td data-v-9dbb6d4c className="bet_history_td">
                        {`${odd.market_name_kor} VS ${odd.market_name_front}`}
                        <br />
                        {convertBetMarketName(odd.market_name)} - 
                        {convertBetHistoryDetail( odd) + (!isEmpty(odd.rank) && (odd.rank != 0) ? ` (${odd.rank}등)` : "")}({Number(odd.rate).toFixed(2)})
                            {/* {`${odd.market_name_front}/${odd.odd_name_front} (${Number(odd.rate).toFixed(2)})`}<br /> */}
                    </td>
                    { oddKey === 0 && <td data-v-9dbb6d4c className="bet_history_td" rowSpan={history.odds.length}>{isEmpty(history.created_date) ? '' : dateFormation(history.created_date, 1)}</td>}
                    { oddKey === 0 && <td data-v-9dbb6d4c className="bet_history_td" rowSpan={history.odds.length}>{isEmpty(history.balance) ? '' : Number(history.balance.bet).toLocaleString()}</td>}
                    { oddKey === 0 && <td data-v-9dbb6d4c className="bet_history_td" rowSpan={history.odds.length}>{isEmpty(history.balance) ? '' : Number(history.balance.win).toLocaleString()}</td>}
                    <td data-v-9dbb6d4c className={`bet_history_td ${convertClass(odd.gameResult)}`} >{convertResultType(odd.gameResult)}</td>
                    { oddKey === 0 && <td data-v-9dbb6d4c className={`bet_history_td ${convertClass(history.type)}`} rowSpan={history.odds.length}>{convertTypeString(history.type)}</td>}
                    </tr>
                ))
                )}
            
        </Fragment>
    )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(BetGameHistory);


// WEBPACK FOOTER //
// ./src/components/account/hisotries/BetGameHistory.js